import brandConfig from '~branding/swiss/config.js'
import VoucherSaleAmountPage from '~brand-pages/swiss/voucher-sale-amount'
import VoucherSaleCheckoutPage from '~brand-pages/swiss/voucher-sale-checkout'
import VoucherSaleConfirmationPage from '~brand-pages/swiss/voucher-sale-confirmation'
import VoucherSaleLandingPage from '~brand-pages/swiss/voucher-sale'
import FAQPage from '~brand-pages/swiss/faq'

import routerBuilder from './routerBuilder'

const router = routerBuilder('swiss', {
  brandConfig,
  TermsOfUsePage: null,
  TermsOfUsePageCompensation: null,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  FAQPage,
  VoucherSaleLandingPage,
}, ['en', 'fr', 'de', 'it'])

export default router
